import React, { useState } from 'react';

export default function DeleteAccount() {
  const [expanded, setExpanded] = useState(false);
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState('');
  const [busy, setBusy] = useState(false);
  async function remove(event) {
    event.preventDefault();
    setBusy(true);
    setStatus('');
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || '/api'}/account`, {
        method: 'DELETE', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
        body: JSON.stringify({ password }),
      });
      if (!response.ok) throw new Error((await response.json()).error || 'Brisanje nije uspjelo.');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('currentFilter');
      if (window.jaosveNative) await window.jaosveNative.flushSession();
      window.location.assign('/');
    } catch (error) { setStatus(error.message); }
    finally { setBusy(false); }
  }
  return <div className="delete-account">
    <button type="button" onClick={() => setExpanded(!expanded)} aria-expanded={expanded}>Izbriši račun</button>
    {expanded && <form onSubmit={remove}>
      <p>Trajno briše račun, spremljene filtere, obavijesti i povezanu analitiku. Za potvrdu unesite trenutnu lozinku.</p>
      <label>Trenutna lozinka <input type="password" autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} disabled={busy} /></label>
      <button type="submit" disabled={busy}>Trajno izbriši moj račun</button>
      {status && <p role="alert">{status}</p>}
    </form>}
  </div>;
}
